import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { BookingNode } from 'modules/space_control/hooks/bookings/useBooking'

import BookingsPopoverMenu from './Menu'

interface Props {
  booking: BookingNode
}
const BookingsActionButtons = ({ booking }: Props) => {
  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd" paddingRight="s24">
      <BookingsPopoverMenu booking={booking} />
    </Box>
  )
}

export default observer(BookingsActionButtons)
